// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/prefer-default-export */
import * as Yup from 'yup';

/**
 * Validates an email address using the same pattern as the Formik validation
 * @param {string} email - Email address to validate
 * @returns {boolean} - true if email is valid, false otherwise
 */
export function isValidEmail(email) {
	if (!email) return false;
	return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
}

export function getMailingAddressValidation() {
	return Yup.object().shape({
		addressLineOne: Yup.string()
			.min(2, 'Too short')
			.max(300, 'Too long')
			.required('Street is required.'),
		addressLineTwo: Yup.string().min(2, 'Too short').max(300, 'Too long'),
		city: Yup.string().min(2, 'Too short').max(300, 'Too long').required('City is required.'),
		// .required('County is required'),
		// TODO if county not presnt, use address to find county some other way?
		// Don't want this to fail if the county is not defined so leaving as not required for now
		state: Yup.string().required('State is required.'),
		zip: Yup.string()
			.matches(/^\d{5}(-\d{4})?$/, 'Zip code is required.')
			.required('Zipcode is required.'),
	});
}

export function getVariantOptionsValidation(vehicles, oemVehicles) {
	const vehicleSchemas = vehicles.reduce((acc, vehicle, index) => {
		acc[`vehicle_${index}`] = Yup.object().shape({
			variant: Yup.string()
				.required('Required')
				.test('is-valid-variant', 'Missing selection', (value) => {
					return (
						oemVehicles[vehicle.productId] &&
						oemVehicles[vehicle.productId].variants &&
						Object.keys(oemVehicles[vehicle.productId].variants).includes(value)
					);
				}),
		});
		return acc;
	}, {});
	return Yup.object().shape(vehicleSchemas);
}

export function getShippingAddressValidation() {
	return Yup.object().shape({
		addressLineOne: Yup.string()
			.min(2, 'Too short')
			.max(300, 'Too long')
			.required('Street is required.'),
		addressLineTwo: Yup.string().min(2, 'Too short').max(300, 'Too long'),
		city: Yup.string().min(2, 'Too short').max(300, 'Too long').required('City is required.'),
		county: Yup.string().min(2, 'Too short').max(300, 'Too long'),
		// .required('County is required'),
		// TODO if county not presnt, use address to find county some other way?
		// Don't want this to fail if the county is not defined so leaving as not required for now
		state: Yup.string().required('State is required.'),
		zip: Yup.string()
			.matches(/^\d{5}(-\d{4})?$/, 'Zip code is required.')
			.required('Zipcode is required.'),
	});
}
